<template>
  <div>
    <v-row v-if="!readonly">
      <v-col cols="12" sm="4" md="4" class="mt-0 pt-0">
        <UsersDropDownList
          label="Internal Employee"
          :userId="userId"
          :readonly="readonly"
          :isRequired="true"
          :securityRoles="[ADMIN, MANAGER, RECRUITER, SALES_PERSON]"
          @userIdChange="handleUserIdChange"
          @userNameChange="handleUserNameChange"
          @userRoleChange="handleUserRoleChange"
        ></UsersDropDownList>
      </v-col>
      <v-col cols="12" sm="4" md="4" class="mt-0 pt-0">
        <BusinessRolesDropDownList
          :businessRoles="role"
          :multiple="false"
          :readonly="readonly"
          @businessRolesChange="handleBusinessRoleChange"
        ></BusinessRolesDropDownList>
      </v-col>
      <v-col cols="8" sm="2" md="2" class="mt-0 pt-0">
        <FormattedNumberField
          label="Commission"
          :value="commission"
          append-icon="percent"
          :readonly="readonly"
          :error="!validCommissionPercentages"
          @valueChange="(newValue) => this.commission = newValue"
        ></FormattedNumberField>
      </v-col>
      <v-col cols="4" sm="2" md="2" class="pt-0">
        <v-btn
          class="mx-1 my-1"
          color="red"
          outlined
          @click="deleteCommissionHandler(commissionInputValue.id)"
        >
          <v-icon color="red">delete</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row v-if="readonly">
      <v-col cols="12" sm="4" class="mt-0 pt-0">
        <UsersDropDownList
          label="Employee"
          :userId="userId"
          :readonly="readonly"
          :isRequired="true"
          :securityRoles="[ADMIN, MANAGER, RECRUITER, SALES_PERSON]"
          @userIdChange="handleUserIdChange"
          @userNameChange="handleUserNameChange"
          @userRoleChange="handleUserRoleChange"
        ></UsersDropDownList>
      </v-col>
      <v-col cols="12" sm="4" class="mt-0 pt-0">
        <BusinessRolesDropDownList
          :businessRoles="role"
          :multiple="false"
          :readonly="readonly"
          @businessRolesChange="handleBusinessRoleChange"
        ></BusinessRolesDropDownList>
      </v-col>
      <v-col cols="12" sm="4" class="mt-0 pt-0">
        <FormattedNumberField
          label="Commission"
          :value="commission"
          append-icon="percent"
          :readonly="readonly"
          @valueChange="(newValue) => this.commission = newValue"
        ></FormattedNumberField>
      </v-col>
    </v-row>
    <ConfirmationModal
      :title="'Delete Confirmation'"
      :contentText="'Are you sure you want to delete the commission?'"
      :toolbarColor="'primary'"
      @cancel-click="() => {
        this.showDeleteConfirmationDialog = false
        this.commissionIdToDelete = null
      }"
      @ok-click="confirmDelete"
      :showModal="showDeleteConfirmationDialog"
    ></ConfirmationModal>
  </div>
</template>

<script>
import { BusinessRolesDropDownList } from '@/components/securityRoles'
import UsersDropDownList from '@/components/users/UsersDropDownList.vue'
import { ADMIN, MANAGER, RECRUITER, SALES_PERSON } from '@/lib/constants/securityRoles'
import { FormattedNumberField } from '@/components/shared/textFields'
import { ConfirmationModal } from '@/components/dialogs'

export default {
  components: {
    BusinessRolesDropDownList,
    UsersDropDownList,
    FormattedNumberField,
    ConfirmationModal
  },
  props: [
    'commissionInput',
    'readonly',
    'validCommissionPercentages'
  ],
  data: () => ({
    isFormValid: false,
    ADMIN,
    MANAGER,
    RECRUITER,
    SALES_PERSON,
    commisionIdToDelete: null,
    showDeleteConfirmationDialog: false
  }),
  computed: {
    commissionInputValue: {
      get () {
        return this.commissionInput
      },
      set (newValue) {
        this.$emit('commissionRowChange', newValue)
      }
    },
    role: {
      get () {
        return this.commissionInput.role
      },
      set (newValue) {
        this.commissionInputValue.role = newValue

        this.$emit('commissionRowChange', this.commissionInputValue)
      }
    },
    userId: {
      get () {
        return this.commissionInput.userId
      },
      set (newValue) {
        this.commissionInputValue.userId = newValue

        this.$emit('commissionRowChange', this.commissionInputValue)
      }
    },
    commission: {
      get () {
        return this.commissionInput.commission
      },
      set (newValue) {
        this.commissionInputValue.commission = newValue

        this.$emit('commissionRowChange', this.commissionInputValue)
        this.$emit('commissionChange')
      }
    }
  },
  methods: {
    handleBusinessRoleChange (value) {
      this.role = value
    },
    handleUserIdChange (value) {
      this.userId = value
    },
    handleUserNameChange (firstName, lastName) {
      this.commissionInputValue.firstName = firstName
      this.commissionInputValue.lastName = lastName
    },
    handleUserRoleChange (securityRoles) {
      let role = securityRoles.find(role => role === 'RECRUITER' || role === 'SALES_PERSON')
      if (role) {
        this.role = role
      }
    },
    deleteCommissionHandler (id) {
      this.commisionIdToDelete = id
      this.showDeleteConfirmationDialog = true
    },
    confirmDelete () {
      this.$emit('remove', this.commisionIdToDelete)
      this.showDeleteConfirmationDialog = false
      this.commisionIdToDelete = null
    }
  }
}
</script>
